import { PARENT_ACCOUNTS } from '../global-constants';

export const checkTopLevelAccount = (ancestorAccountIds) => {
	const topLevelArr = ancestorAccountIds.filter((element) =>
		PARENT_ACCOUNTS.includes(element)
	);

	return topLevelArr.length ? topLevelArr : undefined;
};
